var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarUserChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 -12 30 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 20.4999C28.5228 20.4999 33 16.0227 33 10.4999C33 4.97703 28.5228 0.499878 23 0.499878C17.4772 0.499878 13 4.97703 13 10.4999C13 16.0227 17.4772 20.4999 23 20.4999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.500244 43.75C0.500244 32.5662 9.56648 23.5 20.7502 23.5H25.2502C36.434 23.5 45.5002 32.5662 45.5002 43.75V44C45.5002 44.8284 44.8287 45.5 44.0002 45.5C43.1718 45.5 42.5002 45.5 42.5002 45.5C42.5002 45.5 34.7771 45.4999 25.2502 45.4999H20.7502C11.2233 45.4999 3.50024 45.4999 3.50024 45.4999C3.50024 45.4999 2.82867 45.5 2.00024 45.5C1.17182 45.5 0.500244 44.8284 0.500244 44V43.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarUserChip);
export default __webpack_public_path__ + "static/media/avatarUserChip.f6414079047970e9a39cd92748ed56c3.svg";
export { ForwardRef as ReactComponent };